import store from '../../store'
import localeConstructor from '_locale/Constructor'

export const CHANGE_LOCALE = "CHANGE_LOCALE"

export default function (state = {}, action) {
	switch (action.type) {
		case CHANGE_LOCALE:
			return action.newLocale;
			break;
    default:
      return state
  }
}

export function changeLocale(newLocale) {

	// We create a new locale object and assign it's show() method
	// as global function __
	let locale = new localeConstructor(newLocale); 
	window.__ = locale.init();

 	store.dispatch({
		type: CHANGE_LOCALE,
		newLocale
	});

}



// WEBPACK FOOTER //
// ./src/ducks/Locale/index.js